/* eslint-disable */
export default {
    required: (value: string) => !!value || 'Required field',
    email: (value: string) => /.+@.+\..+/.test(value) || 'E-mail must be valid'
};
